export const TOUR_POPOVER_WIDTH_PX = 300;
export const TOUR_POPOVER_BOTTOM_MARGIN = '-2rem';